import { render } from "./CustomCommonConfig.vue?vue&type=template&id=05ab0be3&scoped=true"
import script from "./CustomCommonConfig.vue?vue&type=script&lang=js"
export * from "./CustomCommonConfig.vue?vue&type=script&lang=js"

import "./CustomCommonConfig.vue?vue&type=style&index=0&id=05ab0be3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ab0be3"],['__file',"src/containers/widget/configs/CustomCommonConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05ab0be3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05ab0be3', __exports__)) {
    api.reload('05ab0be3', __exports__)
  }
  
  module.hot.accept("./CustomCommonConfig.vue?vue&type=template&id=05ab0be3&scoped=true", () => {
    api.rerender('05ab0be3', render)
  })

}


export default __exports__